import frLocale from 'element-ui/lib/locale/lang/fr' //引入element语言包
const fr = {
    posterPage: {
        title1: "La fonction d'abonnement arrive bientôt!",
        title2: "Renouvellement d'abonnement, surclassement de privilèges!",
        title3: 'Rabais exclusifs, renouvellement plus économique',
        title4: "Obtenir un code d'échange, vous pouvez consulter le vendeur qui a acheté l'équipement",
        title5: "Fonctionnalités d'expérience prioritaires",
        function1: 'Détails fonctionnels:',
        function2: 'Renouvellement des services de base (co - traducteur, assistant de conférence, Assistant Intelligent).',
        function3: "Abonnement à des services à valeur ajoutée (traduction hors ligne, traduction d'appels audio - vidéo).",
    },
    RedemptionCodePage: {
        RedemptionCode: "Code d'échange",
        ValueAddedServices: 'Services à valeur ajoutée',
        UpgradedExperience: 'Avantages exclusifs à valeur ajoutée, expérience Upgrade',
        OfflineTranslation: 'Traduction hors ligne',
        NoInternet: 'Pas besoin de mise en réseau · traduction instantanée · sécurité et fiabilité',
        GoToSubscribe: "Aller à l'abonnement",
        AudioAndVideoCall: 'Appels audio / vidéo',
        RealTimeCall: 'Traduction vocale en temps réel · accessibilité de la communication',
        BaseService: 'Services de base',
        AIAssistant: 'Fonctions: co - traducteur · assistant de conférence · assistant ai',
        LanguagesSetting: 'Paramètres de langue',
        languages1: 'Chinois simplifié',
        languages2: 'Chinois traditionnel',
        languages3: 'Anglais',
        languages4: 'Japonais',
        languages5: 'Coréen',
        languages6: 'Russe',
        languages7: 'Espagnol',
        languages8: 'Français',
        languages9: 'Allemand',
        languages10: 'Portugais',
        languages11: 'Italien',
        languages12: 'Turc',
        languages13: 'Vietnamien',
        languages14: 'Indonésien',
        languages15: 'Hindi',
        languages16: 'Arabe',
        languages17: 'Thaï',
        languages18: 'Persan',
    },
    Login: {
        ToLogin: 'Se connecter',
        PhoneLogin: 'Numéro de téléphone mobile login',
        EmailLogin: 'Mailbox login',
        PhonePlaceholder: 'Veuillez entrer le numéro de téléphone portable',
        EmailPlaceholder: 'Enter email',
        Code: 'Code de vérification',
        and: 'Et',
        BeforeText: 'Créer un compte tout en acceptant et en respectant en votre nom',
        UserAgreement: 'Accord utilisateur',
        privacy: 'Politique de confidentialité',
        errorMessage: 'Erreur de code de vérification',
        readTitle: "Lire et accepter l'accord suivant",
        readBefore: "Pour garantir la sécurité de vos informations personnelles, veuillez d'abord lire et accepter",
        cancel: 'Annulation',
        agree: 'Accepter et continuer',
        error1: 'Veuillez entrer une adresse Email valide',
        error2: 'Veuillez entrer le bon numéro de téléphone portable',
        error3: 'Veuillez entrer le Code de vérification',
        success: 'Connexion réussie'
    },
    OffLinePage: {
        title: 'Traduction hors ligne',
        NoInternet: 'Pas besoin de mise en réseau · traduction instantanée · sécurité et fiabilité',
        ServiceLife: "Durée d'utilisation",
        forever: 'Utilisation permanente',
        describe: "Description de l'abonnement",
        describeItem1: "1.La fonction de traduction hors ligne est payante une fois pour toutes, pour une utilisation permanente, utilisez les autorisations pour suivre l'appareil Bluetooth, si vous remplacez l'appareil, vous devez vous réabonner au Code d'échange de traduction hors ligne.",
        describeItem2: "2. Non remboursable après l'abonnement de code d'autorisation.",
        describeItem3: '3. Soutenez 10 langues: chinois, anglais, allemand, japonais, coréen, hindi, thaï, espagnol, français, russe.',
        quantity: 'Quantité',
        payType: 'Mode de paiement',
        card: 'Carte bancaire',
        wx: 'Wechat',
        GooglePay: 'Google Pay',
        subscribe: "S'abonner",
        RMB: '¥',
        confirm: 'Confirmation',
        cardNumber: 'Numéro de carte',
        periodOfValidity: 'Période de validité',
        safetyCode: 'Code de sécurité',
        name: 'Nom et prénom',
        yearAndMonth: 'Année / mois',
        message1: 'La quantité ne peut pas être 0',
        popTip:'Conseils chaleureux',
        popText1:"Veuillez lire attentivement et comprendre",
        popText2:"Traduction hors ligne accord payant",
        popText3:"J'ai lu et j'accepte",
        popText4:"Lu et accepté",
    },
    AudioVideoPage: {
        title: 'Appels audio / vidéo',
        RealTime: 'Traduction vocale en temps réel · accessibilité de la communication',
        describe: "Description de l'abonnement",
        describeItem1: "1. Fonction de traduction d'appel audio - vidéo pour recharger le nombre de minutes d'achat, le nombre de minutes est calculé à partir du début de l'appel, l'autorisation suit le numéro de compte, si vous vous connectez à un autre compte, vous devez recharger.",
        describeItem2: "2. Connecter et lier différents appareils après la recharge du compte peut être utilisé comme d'habitude.",
        describeItem3: "3. Les frais ne sont pas remboursables une fois la fonction de traduction d'appel audio - vidéo rechargée.",
        payType: 'Mode de paiement',
        card: 'Carte bancaire',
        wx: 'Wechat',
        GooglePay: 'Google Pay',
        subscribe: "S'abonner",
        RMB: '¥',
        sale: 'Réductions',
        confirm: 'Confirmation',
        time1: 'Secondes',
        time2: 'Minutes',
        time3: 'Heures',
        time4: 'Jours',
        time5: 'Mois',
        time6: 'Année',
    },
    OffLineResult: {
        title1: 'Traduction hors ligne',
        title2: 'Appels audio / vidéo',
        title3: 'Services de base',
        success: 'Abonnement réussi',
        fail: "L'abonnement a échoué",
        stock: "Code d'échange en stock",
        saveTitle: "Enregistrez le Code d'échange, allez à l'app pour l'utiliser",
        code: "Code d'échange",
        tip1: "Ce code est utilisé uniquement pour la fonction de traduction hors ligne",
        tip2: "Ce code est utilisé uniquement pour la fonction de traduction d'appels audio / vidéo",
        tip3: "Ce code est utilisé uniquement pour la fonction de renouvellement du Service de base",
        save: 'Sauvegarder',
        time: "Durée de l'abonnement:",
        copy: 'Copier',
        copySuccess: 'Copie réussie',
        loading: 'En chargement',
        paySuccess:'Paiement réussi'
    },
    RedemptionList: {
        title: "Mon code d'échange",
        view: 'Voir',
        time: "Durée de l'abonnement:",
    },
    MyRedemption: {
        title: "Mon code d'échange",
        code: "Code d'échange",
        time: "Durée de l'abonnement:",
        copy: 'Copier',
        tip1: "Ce code est utilisé uniquement pour la fonction de traduction hors ligne",
        tip2: "Ce code est utilisé uniquement pour la fonction de traduction d'appels audio / vidéo",
        tip3: "Ce code est utilisé uniquement pour la fonction de renouvellement du Service de base",
        save: 'Sauvegarder',
        success: "Opération réussie"
    },
    basePage: {
        error1: 'Aucune information sur les marchandises obtenue',
        message1: 'Veuillez sélectionner un article',
        title: 'Services de base',
        function: 'Fonctions: co - traducteur · assistant de conférence · assistant ai',
        describe: "Description de l'abonnement",
        describe1: "1. Après le renouvellement des services de base tels que le traducteur, l'assistant de conférence, etc., la période de validité suit l'équipement, si l'équipement est remplacé, il doit être renouvelé.",
        describe2: "2. Frais non remboursables après le renouvellement du Service de base.",
        payType: 'Mode de paiement',
        card: 'Carte bancaire',
        wx: 'Wechat',
        GooglePay: 'Google Pay',
        subscribe: "S'abonner",
        RMB: '¥',
        sale: 'Réductions',
        month: 'Mois',
        confirm: 'Confirmation',
        month1: '1 mois',
        month2: 'Demi - année',
        month3: '1 année'
    },
    ...frLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default fr;
